import { jsx as i } from "react/jsx-runtime";
import { _ as t } from "../../cs-Dfox81s-.js";
import "../../type-Dku6Xzl6.js";
import b from "../InlineLayout/index.js";
import '../../index31.css';const B = "_inline-view_1s7si_1", g = "_with-sm-wrap-breakpoint_1s7si_2", N = "_with-md-wrap-breakpoint_1s7si_3", W = "_with-lg-wrap-breakpoint_1s7si_4", y = "_inline-layout_1s7si_10", L = "_before-content_1s7si_11", S = "_after-content_1s7si_19", e = {
  inlineView: B,
  withSmWrapBreakpoint: g,
  withMdWrapBreakpoint: N,
  withLgWrapBreakpoint: W,
  inlineLayout: y,
  beforeContent: L,
  afterContent: S
};
function x(a) {
  const {
    layoutElementRef: o,
    layoutClassName: r,
    className: s,
    elementRef: p,
    before: l,
    beforeContainerClassName: m,
    children: f,
    childrenContainerClassName: c,
    after: w,
    afterContainerClassName: _,
    spacing: C,
    spacingOffset: h,
    withPadding: d,
    withoutSpacingOpticalCorrection: k,
    wrapBreakpoint: n = "md",
    ...u
  } = a;
  return /* @__PURE__ */ i(
    "div",
    {
      ...u,
      ref: p,
      className: t(
        e.inlineView,
        n === "sm" && e.withSmWrapBreakpoint,
        n === "md" && e.withMdWrapBreakpoint,
        n === "lg" && e.withLgWrapBreakpoint,
        s
      ),
      children: /* @__PURE__ */ i(
        b,
        {
          className: t(e.inlineLayout, r),
          elementRef: o,
          before: l,
          beforeContainerClassName: t(e.beforeContent, m),
          childrenContainerClassName: c,
          after: w,
          afterContainerClassName: t(e.afterContent, _),
          spacing: C,
          spacingOffset: h,
          withPadding: d,
          withoutSpacingOpticalCorrection: k,
          children: f
        }
      )
    }
  );
}
export {
  x as default
};
